import { render, staticRenderFns } from "./jump-config.vue?vue&type=template&id=d70983bc&scoped=true"
import script from "./jump-config.vue?vue&type=script&lang=js"
export * from "./jump-config.vue?vue&type=script&lang=js"
import style0 from "./jump-config.vue?vue&type=style&index=0&id=d70983bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70983bc",
  null
  
)

export default component.exports